import * as Sentry from "@sentry/browser";
import { redirect, useRouteError } from "react-router-dom";
import ErrorBoundaryComponent from "../components/ErrorBoundary";
import { requireAuthedUser } from "../helpers/auth";

function ErrorBoundary() {
  const error = useRouteError();
  // eslint-disable-next-line no-console
  console.error(error);
  Sentry.captureException(error);
  return <ErrorBoundaryComponent error={error} />;
}

// RouteObject type per https://github.com/remix-run/react-router/blob/a3e4b8ed875611637357647fcf862c2bc61f4e11/packages/react-router/lib/context.ts#L65
const defaultRoute = {
  loader: async (context) => {
    await requireAuthedUser(context);
    return null;
  },
  errorElement: <ErrorBoundary />,
};

const buildRoute = (routeArgs) => {
  return { ...defaultRoute, ...routeArgs };
};

export default buildRoute;
